import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {LinhaExtrato} from '../../../core/linha-extrato';
import {AssociacaoLinhaExtrato} from '../../../core/associacao-linha-extrato';
import {CategoriasContabeisService} from '../../../services/categorias-contabeis/categorias-contabeis.service';
import {ContasBancariaService} from '../../../services/contas-bancaria/contas-bancaria.service';
import {ContasBancaria} from '../../../core/contas-bancaria';
import {ToastService} from '../../../services/toast/toast.service';
import {LoadingPopupService} from '../../../services/loadingPopup/loading-popup.service';
import {ArquivoExtratoService} from '../../../services/arquivo-extrato/arquivo-extrato.service';
import {ArquivoExtrato} from '../../../core/arquivo-extrato';
import {ConfiguracaoSeletor, OpcaoSelecao} from '../../shared/interfaces/opcao-selecao.interface';
import {
    ConjuntoCategoriaContabilService
} from '../../../services/conjunto-categoria-contabil/conjunto-categoria-contabil.service';
import {ConjuntoCategoriaContabil} from '../../../core/conjunto-categoria-contabil';
import {
    CadastrarConjuntoCategoriaContabilDialogComponent
} from './cadastrar-conjunto-categoria-contabil-dialog/cadastrar-conjunto-categoria-contabil-dialog.component';
import {ConfirmDialogComponent} from '../../common/confirm-dialog/confirm-dialog.component';
import {
    SelecionarConjuntoCategoriaContabilDialogComponent
} from './selecionar-conjunto-categoria-contabil-dialog/selecionar-conjunto-categoria-contabil-dialog.component';
import {EscolherTipoAssociacaoDialogComponent} from './escolher-tipo-associacao-dialog/escolher-tipo-associacao-dialog.component';
import {Acesso} from '../../../core/acesso';
import {CarregarPerfil} from '../../../core/carregar-perfil';
import {switchMap} from 'rxjs/operators';
import * as _ from 'lodash';
import {of} from 'rxjs';
import {AcessoService} from '../../../services/acesso/acesso.service';
import {PlanosContas} from '../../../core/planos-contas';
import {EmpresaService} from '../../../services/empresa/empresa.service';
import {Empresa} from '../../../core/empresa';
import {TipoLancamentoExtrato} from '../../../core/tipo-lancamento-extrato';
import {TipoLancamentoExtratoService} from '../../../services/tipo-lancamento-extrato/tipo-lancamento-extrato.service';

@Component({
    selector: 'associar-linhas',
    templateUrl: './associar-linhas.component.html',
    styleUrls: ['./associar-linhas.component.css']
})
export class AssociarLinhasComponent implements OnInit {

    arquivo: ArquivoExtrato;
    linhas: LinhaExtrato[] = [];
    planosContas: PlanosContas[] = [];
    empresas: Empresa[] = [];
    tiposLancamento: TipoLancamentoExtrato[] = [];
    contasBancarias: ContasBancaria[] = [];
    contasBancariasOpcoes: OpcaoSelecao[] = [];
    associacoes: Map<number, AssociacaoLinhaExtrato> = new Map();
    filtroSelecionado = 'validas';

    // Permission properties
    perfilAcesso: Acesso = new Acesso();
    perfilAcessoSec: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    // Configuração para o seletor genérico
    configuracaoSeletorCategoria: ConfiguracaoSeletor = {
        mostrarOpcaoVazia: true,
        textoOpcaoVazia: 'Selecione uma categoria contábil',
        campoExibicao: 'planoConta',
        campoValor: 'id',
        habilitarPesquisa: true,
        camposPesquisa: ['planoConta'],
        tamanhoMinimoPesquisa: 1,
        panelClass: 'combo-generico-panel'
    };

    configuracaoSeletorContaBancaria: ConfiguracaoSeletor = {
        textoOpcaoVazia: 'Selecione uma conta bancária',
        campoExibicao: 'nome',
        campoValor: 'id',
        habilitarPesquisa: true,
        camposPesquisa: ['nome'],
        tamanhoMinimoPesquisa: 1,
        panelClass: 'combo-generico-panel'
    };

    configuracaoSeletorEmpresa: ConfiguracaoSeletor = {
        mostrarOpcaoVazia: true,
        textoOpcaoVazia: 'Selecione uma empresa',
        campoExibicao: 'nomeRazaoSocial',
        campoValor: 'id',
        habilitarPesquisa: true,
        camposPesquisa: ['nomeRazaoSocial'],
        tamanhoMinimoPesquisa: 1,
        panelClass: 'combo-generico-panel'
    };

    // Configuração do seletor de tipo de importação (exibe somente a descrição do tipo)
    configuracaoSeletorTipoLancamento: ConfiguracaoSeletor = {
        mostrarOpcaoVazia: true,
        textoOpcaoVazia: 'Selecione um tipo de importação',
        campoExibicao: 'descricao',
        campoValor: 'id',
        habilitarPesquisa: false,
        panelClass: 'combo-generico-panel'
    };

    // Estatísticas detalhadas
    estatisticas: any = {
        totalLinhas: 0,
        associadas: 0,
        semContaContabil: 0,
        ignoradas: 0,
        duplicadas: 0,
        pendentesIntegracao: 0,
        percentualAssociacao: 0,
        statusAssociacao: '',
        valorTotal: 0,
        valorAssociado: 0,
        valorPendente: 0,
        valorIgnorado: 0,
        valorDuplicado: 0
    };

    resumoExpandido: boolean = true;
    configuracaoAlterada: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private categoriasContabeisService: CategoriasContabeisService,
        private contasBancariaService: ContasBancariaService,
        private arquivoExtratoService: ArquivoExtratoService,
        private conjuntoCategoriaContabilService: ConjuntoCategoriaContabilService,
        private toastService: ToastService,
        private loadingPopupService: LoadingPopupService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private acessoService: AcessoService,
        private empresaService: EmpresaService,
        private tipoLancamentoExtratoService: TipoLancamentoExtratoService) {
    }

    ngOnInit(): void {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
        this.carregarPerfilSecundario();

        const idArquivo = this.route.snapshot.params['id'];
        if (idArquivo) {
            this.carregarArquivo(idArquivo);
            this.carregarDados();
        } else {
            this.toastService.showAlerta('ID do arquivo não informado');
            this.voltar();
        }
    }

    carregarArquivo(idArquivo: number): void {
        this.loadingPopupService.mostrarMensagemDialog('Carregando arquivo...');
        this.configuracaoAlterada = false;

        this.arquivoExtratoService.getById(idArquivo).subscribe({
            next: (arquivo) => {
                this.arquivo = arquivo as ArquivoExtrato;
                this.linhas = this.arquivo.linhasExtrato || [];
                this.calcularEstatisticas();
            },
            error: (error) => {
                console.error('Erro ao carregar arquivo:', error);
                this.loadingPopupService.closeDialog();
                this.toastService.showAlerta('Erro ao carregar arquivo. Tente novamente.');
                this.voltar();
            }
        });
    }

    carregarDados(): void {
        this.loadingPopupService.mostrarMensagemDialog('Carregando dados...');

        // Load categories, bank accounts, empresas and tipos de importação in parallel
        Promise.all([
            this.categoriasContabeisService.getAllViewReverso(false).toPromise(),
            this.contasBancariaService.getAllComboByInstituicaoLogada().toPromise(),
            this.empresaService.getAllCombo().toPromise(),
            this.tipoLancamentoExtratoService.getAll().toPromise()
        ]).then(([planosContas, contasBancarias, empresas, tiposLancamento]) => {
            this.planosContas = planosContas as PlanosContas[] || [];
            this.contasBancarias = contasBancarias as ContasBancaria[] || [];
            this.empresas = empresas as Empresa[] || [];
            this.tiposLancamento = tiposLancamento as TipoLancamentoExtrato[] || [];
            this.converterContasBancariasParaOpcoes();
            this.loadingPopupService.closeDialog();
        }).catch(error => {
            console.error('Erro ao carregar dados:', error);
            this.loadingPopupService.closeDialog();
            this.toastService.showAlerta('Erro ao carregar dados. Tente novamente.');
        });
    }

    obterLinhasFiltradas(): LinhaExtrato[] {
        let linhasFiltradas = this.linhas.filter(linha => !linha.importado);

        switch (this.filtroSelecionado) {
            case 'semContaContabil':
                linhasFiltradas = linhasFiltradas.filter(linha =>
                    linha.statusProcessado !== 'S' && linha.statusProcessado !== 'I'
                );
                break;
            case 'ignoradas':
                linhasFiltradas = linhasFiltradas.filter(linha => this.isLinhaIgnorada(linha));
                break;
            case 'validas':
                linhasFiltradas = linhasFiltradas.filter(linha => linha.statusProcessado !== 'I');
                break;
            case 'duplicadas':
                linhasFiltradas = linhasFiltradas.filter(linha => linha.statusProcessado === 'I');
                break;
            case 'todas':
            default:
                break;
        }

        return linhasFiltradas.sort((a, b) => {
            const dataA = new Date(a.dataExtrato).getTime();
            const dataB = new Date(b.dataExtrato).getTime();
            if (dataA !== dataB) return dataA - dataB;
            return a.id - b.id;
        });
    }

    obterLinhasImportadas(): LinhaExtrato[] {
        return this.linhas.filter(l => l.importado && l.statusAtualizadoBase === 'S').sort((a, b) => {
            const dataA = new Date(a.dataExtrato).getTime();
            const dataB = new Date(b.dataExtrato).getTime();
            if (dataA !== dataB) return dataA - dataB;
            return a.id - b.id;
        });
    }

    obterLinhasPendentesIntegracao(): LinhaExtrato[] {
        return this.linhas.filter(l => l.importado && l.statusAtualizadoBase !== 'S').sort((a, b) => {
            const dataA = new Date(a.dataExtrato).getTime();
            const dataB = new Date(b.dataExtrato).getTime();
            if (dataA !== dataB) return dataA - dataB;
            return a.id - b.id;
        });
    }

    contarPendentesIntegracao(): number {
        return this.obterLinhasPendentesIntegracao().length;
    }

    marcarComoCorrigido(linha: LinhaExtrato): void {
        this.loadingPopupService.mostrarMensagemDialog('Marcando como corrigido...');
        this.arquivoExtratoService.marcarLinhaCorrigida(this.arquivo.id, linha.id).subscribe({
            next: () => {
                this.loadingPopupService.closeDialog();
                this.toastService.showSucesso('Linha marcada como corrigida com sucesso!');
                this.carregarArquivo(this.arquivo.id);
            },
            error: (error) => {
                console.error('Erro ao marcar linha como corrigida:', error);
                this.loadingPopupService.closeDialog();
                this.toastService.showAlerta('Erro ao marcar como corrigido. Tente novamente.');
            }
        });
    }

    reprocessarArquivo(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: 'Deseja reprocessar a integração deste arquivo? Isso irá re-executar o processo de integração para todas as linhas importadas.',
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma: boolean) => {
            if (confirma) {
                this.loadingPopupService.mostrarMensagemDialog('Reprocessando integração...');
                this.arquivoExtratoService.reprocessar(this.arquivo.id).subscribe({
                    next: (resultado) => {
                        this.loadingPopupService.closeDialog();
                        this.toastService.showSucesso(resultado || 'Reprocessamento concluído com sucesso!');
                        this.carregarArquivo(this.arquivo.id);
                    },
                    error: (error) => {
                        console.error('Erro ao reprocessar:', error);
                        this.loadingPopupService.closeDialog();
                        this.toastService.showAlerta('Erro ao reprocessar. Tente novamente.');
                    }
                });
            }
        });
    }

    isLinhaPendenciaModificada(linha: LinhaExtrato): boolean {
        return this.associacoes.has(linha.id);
    }

    contarPendentesTotal(): number {
        return this.linhas.filter(l => !l.importado && l.statusProcessado !== 'I' && !this.isLinhaIgnorada(l) &&
            (l.statusProcessado !== 'S')).length;
    }

    onCategoriaOrigemChange(linha: LinhaExtrato, categoriaId: number): void {
        // Origem só é editável para linhas de crédito
        if (linha.tipoTransacao === 'C') {
            this.atualizarAssociacao(linha, 'categoriaOrigem', categoriaId);
        }
    }

    onCategoriaDestinoChange(linha: LinhaExtrato, categoriaId: number): void {
        // Destino só é editável para linhas de débito
        if (linha.tipoTransacao === 'D') {
            this.atualizarAssociacao(linha, 'categoriaDestino', categoriaId);
        }
    }

    onCategoriaChange(linha: LinhaExtrato, categoriaId: number): void {
        // Processo unificado que determina automaticamente se é origem ou destino
        // baseado no tipo de transação
        if (linha.tipoTransacao === 'D') {
            // Débito: atualiza destino
            this.onCategoriaDestinoChange(linha, categoriaId);
        } else if (linha.tipoTransacao === 'C') {
            // Crédito: atualiza origem
            this.onCategoriaOrigemChange(linha, categoriaId);
        }
    }

    onCategoriaAdicionalChange(linha: LinhaExtrato, categoriaId: number | null): void {
        const planoConta = categoriaId ? _.cloneDeep(_.find(this.planosContas, {id: categoriaId})) : null;
        linha.categoriaAdicional = planoConta || undefined;
        this.atualizarAssociacao(linha, 'categoriaAdicional', categoriaId);
    }

    onEmpresaChange(linha: LinhaExtrato, empresaId: number | null): void {
        const empresa = empresaId ? this.empresas.find(e => e.id === empresaId) : null;
        linha.empresa = empresa || undefined;
        this.atualizarAssociacao(linha, 'empresa', empresaId);
    }

    onTipoLancamentoChange(linha: LinhaExtrato, idTipoLancamento: number | null): void {
        const tipoLancamento = idTipoLancamento ? this.tiposLancamento.find(t => t.id === idTipoLancamento) : null;
        linha.tipoLancamento = tipoLancamento || undefined;
        this.atualizarAssociacao(linha, 'tipoLancamento', idTipoLancamento);
    }

    getCategoriaIdLinha(linha: LinhaExtrato): number | null {
        // Retorna o ID da categoria apropriada baseado no tipo de transação
        if (linha.tipoTransacao === 'D') {
            // Débito: retorna destino
            return linha.categoriaDestino?.id || null;
        } else if (linha.tipoTransacao === 'C') {
            // Crédito: retorna origem
            return linha.categoriaOrigem?.id || null;
        }
        return null;
    }

    getCategoriaAdicionalIdLinha(linha: LinhaExtrato): number | null {
        return linha.categoriaAdicional?.id ?? null;
    }

    getEmpresaIdLinha(linha: LinhaExtrato): number | null {
        return linha.empresa?.id ?? null;
    }

    getTipoLancamentoIdLinha(linha: LinhaExtrato): number | null {
        return linha.tipoLancamento?.id ?? null;
    }

    onCategoriaArquivoChange(categoriaId: number): void {
        if (!categoriaId) {
            this.arquivo.categoriaContabil = null;
            return;
        }

        // Atualizar categoria no objeto local
        const planoConta = _.cloneDeep(_.find(this.planosContas, {id: categoriaId}));
        if (planoConta) {
            this.arquivo.categoriaContabil = planoConta;
        }

        // Atualizar todas as linhas já associadas
        this.atualizarLinhasAssociadasComNovaCategoria(categoriaId);

        // Mostrar mensagem ao usuário
        this.toastService.showSucesso('Categoria do arquivo atualizada. Clique em "Salvar Todas" para aplicar as mudanças.');

        // Recalcular estatísticas
        this.calcularEstatisticas();
        this.configuracaoAlterada = true;
    }

    onContaBancariaChange(contaId: number): void {
        if (!contaId) {
            this.arquivo.contaBancaria = null;
            return;
        }

        // Atualizar conta bancária no objeto local
        const conta = this.contasBancarias.find(c => c.id === contaId);
        if (conta) {
            this.arquivo.contaBancaria = conta;
        }

        // Mostrar mensagem ao usuário
        this.toastService.showSucesso('Conta bancária do arquivo atualizada. Clique em "Salvar Todas" para aplicar as mudanças.');
        this.configuracaoAlterada = true;
    }

    private atualizarLinhasAssociadasComNovaCategoria(categoriaId: number): void {
        const planoConta = _.cloneDeep(_.find(this.planosContas, {id: categoriaId}))
        if (!planoConta) {
            return;
        }

        // Percorrer todas as linhas associadas (não ignoradas)
        this.linhas.forEach(linha => {
            // Ignorar linhas ignoradas
            if (this.isLinhaIgnorada(linha)) {
                return;
            }

            // Verificar se a linha está associada
            const estaAssociada = this.isLinhaAssociada(linha);

            if (estaAssociada) {
                // Para débito: atualizar origem (que vem do arquivo)
                if (linha.tipoTransacao === 'D') {
                    linha.categoriaOrigem = planoConta;
                    // Adicionar à fila de associações pendentes
                    if (!this.associacoes.has(linha.id)) {
                        this.associacoes.set(linha.id, {
                            idLinhaExtrato: linha.id,
                            idCategoriaOrigem: categoriaId,
                            idCategoriaDestino: linha.categoriaDestino?.id || null,
                            idCategoriaAdicional: linha.categoriaAdicional?.id ?? undefined,
                            idEmpresa: linha.empresa?.id ?? undefined,
                            idTipoLancamento: linha.tipoLancamento?.id ?? undefined,
                            observacoes: linha.observacoes,
                            descricaoLinha: linha.descricaoLinha,
                            ignorar: false
                        });
                    } else {
                        const associacao = this.associacoes.get(linha.id);
                        associacao.idCategoriaOrigem = categoriaId;
                    }
                }
                // Para crédito: atualizar destino (que vem do arquivo)
                else if (linha.tipoTransacao === 'C') {
                    linha.categoriaDestino = planoConta;
                    // Adicionar à fila de associações pendentes
                    if (!this.associacoes.has(linha.id)) {
                        this.associacoes.set(linha.id, {
                            idLinhaExtrato: linha.id,
                            idCategoriaOrigem: linha.categoriaOrigem?.id || null,
                            idCategoriaDestino: categoriaId,
                            idCategoriaAdicional: linha.categoriaAdicional?.id ?? undefined,
                            idEmpresa: linha.empresa?.id ?? undefined,
                            idTipoLancamento: linha.tipoLancamento?.id ?? undefined,
                            observacoes: linha.observacoes,
                            descricaoLinha: linha.descricaoLinha,
                            ignorar: false
                        });
                    } else {
                        const associacao = this.associacoes.get(linha.id);
                        associacao.idCategoriaDestino = categoriaId;
                    }
                }
            }
        });
    }

    onDescricaoLinhaChange(linha: LinhaExtrato, descricao: string): void {
        this.atualizarAssociacao(linha, 'descricaoLinha', descricao);
    }

    ignorarLinha(linha: LinhaExtrato): void {
        if (!this.associacoes.has(linha.id)) {
            this.associacoes.set(linha.id, {
                idLinhaExtrato: linha.id,
                idCategoriaOrigem: null,
                idCategoriaDestino: null,
                idCategoriaAdicional: linha.categoriaAdicional?.id ?? undefined,
                idEmpresa: linha.empresa?.id ?? undefined,
                idTipoLancamento: linha.tipoLancamento?.id ?? undefined,
                observacoes: null,
                descricaoLinha: null,
                ignorar: true
            });
        } else {
            const associacao = this.associacoes.get(linha.id);
            associacao.ignorar = true;
        }
    }

    salvarTodas(): void {
        const associacoesParaSalvar = Array.from(this.associacoes.values());
        const payload: any = {};

        if (this.arquivo.categoriaContabil?.id && !this.arquivo.finalizado) {
            payload.idCategoria = this.arquivo.categoriaContabil.id;
        }
        if (this.arquivo.contaBancaria?.id && !this.arquivo.finalizado) {
            payload.idConta = this.arquivo.contaBancaria.id;
        }
        if (associacoesParaSalvar.length > 0) {
            payload.associacoes = associacoesParaSalvar;
        }

        if (Object.keys(payload).length === 0) {
            this.toastService.showAlerta('Nenhuma alteração para salvar.');
            return;
        }

        this.loadingPopupService.mostrarMensagemDialog('Salvando alterações...');

        this.arquivoExtratoService.alterarArquivoExtrato(this.arquivo.id, payload).subscribe({
            next: () => {
                this.loadingPopupService.closeDialog();
                this.toastService.showSucesso('Todas as alterações salvas com sucesso!');
                this.carregarArquivo(this.arquivo.id); // Recarregar dados para refletir as mudanças
                this.associacoes.clear(); // Limpar alterações pendentes
                this.configuracaoAlterada = false;
            },
            error: (error) => {
                console.error('Erro ao salvar alterações:', error);
                this.loadingPopupService.closeDialog();
                this.toastService.showAlerta('Erro ao salvar alterações. Tente novamente.');
            }
        });
    }

    finalizarImportacao(): void {
        if (!this.arquivo.categoriaContabil?.id || !this.arquivo.contaBancaria?.id) {
            this.toastService.showAlerta('Configure a Conta Contábil e a Categoria Contábil do Arquivo para finalizar a importação.');
            return;
        }

        // Confirmar com o usuário
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: 'Deseja finalizar a importação deste arquivo? Após a finalização, não será possível realizar mais alterações e transações duplicadas serão invalidadas.',
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma: boolean) => {
            if (confirma) {
                this.executarFinalizacao();
            }
        });
    }

    private executarFinalizacao(): void {
        const associacoesParaSalvar = Array.from(this.associacoes.values());
        const payload: any = {};

        if (this.arquivo.categoriaContabil?.id) {
            payload.idCategoria = this.arquivo.categoriaContabil.id;
        }
        if (this.arquivo.contaBancaria?.id) {
            payload.idConta = this.arquivo.contaBancaria.id;
        }
        if (associacoesParaSalvar.length > 0) {
            payload.associacoes = associacoesParaSalvar;
        }

        this.loadingPopupService.mostrarMensagemDialog('Salvando alterações e finalizando importação...');

        if (Object.keys(payload).length > 0) {
            this.arquivoExtratoService.alterarArquivoExtrato(this.arquivo.id, payload).subscribe({
                next: () => {
                    this.executarFinalizacaoBackend();
                },
                error: (error) => {
                    console.error('Erro ao salvar alterações:', error);
                    this.loadingPopupService.closeDialog();
                    this.toastService.showAlerta('Erro ao salvar alterações. A finalização foi cancelada.');
                }
            });
        } else {
            this.executarFinalizacaoBackend();
        }
    }

    private executarFinalizacaoBackend(): void {
        this.arquivoExtratoService.finalizarImportacao(this.arquivo.id).subscribe({
            next: (resultado) => {
                this.loadingPopupService.closeDialog();
                this.associacoes.clear(); // Limpar alterações pendentes

                // Atualizar status do arquivo localmente
                this.arquivo.finalizado = true;

                this.toastService.showSucesso(resultado || 'Importação realizada com sucesso!');

                // Resetar flag de configuração alterada e valores originais
                this.configuracaoAlterada = false;

                // Recarregar dados para refletir as mudanças
                this.carregarArquivo(this.arquivo.id);
            },
            error: (error) => {
                console.error('Erro ao finalizar importação:', error);
                this.loadingPopupService.closeDialog();
                const mensagemErro = error.error?.message || 'Erro ao finalizar importação. Tente novamente.';
                this.toastService.showAlerta(mensagemErro);
            }
        });
    }

    desabilitarBotaoImportar(): boolean {
        return this.linhas.every(linha => linha.importado || linha.statusProcessado === 'I')
            && (this.associacoes.size === 0 ||
                Array.from(this.associacoes.values()).every(associacao => !associacao.idCategoriaDestino && !associacao.idCategoriaOrigem || associacao.ignorar));
    }

    voltar(): void {
        this.router.navigate(['/arquivo-extrato']);
    }

    formatarValor(valor: number): string {
        if (valor === null || valor === undefined) return '-';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    }

    formatarData(data: Date): string {
        if (!data) return '-';
        return new Date(data).toLocaleDateString('pt-BR');
    }

    obterCorValor(valor: number): string {
        if (valor > 0) return '#4caf50'; // Green for credit
        if (valor < 0) return '#f44336'; // Red for debit
        return '#666';
    }

    isLinhaModificada(linha: LinhaExtrato): boolean {
        return this.associacoes.has(linha.id);
    }

    isLinhaIgnorada(linha: LinhaExtrato): boolean {
        const associacao = this.associacoes.get(linha.id);
        if (associacao) {
            return associacao.ignorar;
        }

        return linha.ignorar || false;
    }

    isLinhaAssociada(linha: LinhaExtrato): boolean {
        // Verificar se a linha está associada baseado no tipo de transação
        if (this.isLinhaIgnorada(linha)) {
            return false;
        }

        // Para débito: precisa ter categoriaDestino (origem vem do arquivo)
        if (linha.tipoTransacao === 'D') {
            return !!linha.categoriaDestino?.id && !!this.arquivo.categoriaContabil?.id;
        }

        // Para crédito: precisa ter categoriaOrigem (destino vem do arquivo)
        if (linha.tipoTransacao === 'C') {
            return !!linha.categoriaOrigem?.id && !!this.arquivo.categoriaContabil?.id;
        }

        return false;
    }

    desfazerIgnorarLinha(linha: LinhaExtrato): void {
        if (!this.associacoes.has(linha.id)) {
            this.associacoes.set(linha.id, {
                idLinhaExtrato: linha.id,
                idCategoriaOrigem: linha.categoriaOrigem?.id || null,
                idCategoriaDestino: linha.categoriaDestino?.id || null,
                idCategoriaAdicional: linha.categoriaAdicional?.id ?? undefined,
                idEmpresa: linha.empresa?.id ?? undefined,
                idTipoLancamento: linha.tipoLancamento?.id ?? undefined,
                observacoes: linha.observacoes,
                descricaoLinha: linha.descricaoLinha,
                ignorar: false
            });
        } else {
            const associacao = this.associacoes.get(linha.id);
            associacao.ignorar = false;
        }
    }

    preencherCategoriaAutomaticamente(linha: LinhaExtrato): void {
        // Verificar se a linha pode ser processada
        if (this.isLinhaIgnorada(linha)) {
            this.toastService.showAlerta('Esta linha está ignorada e não pode ser processada.');
            return;
        }

        // Verificar se o arquivo tem conta contábil
        if (!this.podePreencherAutomaticamente()) {
            this.toastService.showAlerta('Configure a Conta Contábil do Arquivo para usar o preenchimento automático.');
            return;
        }

        this.loadingPopupService.mostrarMensagemDialog('Processando preenchimento automático...');

        // Determinar categoria origem ou destino baseado no tipo de transação
        let categoriaOrigem: number | undefined;
        let categoriaDestino: number | undefined;

        if (linha.tipoTransacao === 'D') {
            // Para débito: a origem é a conta contábil do arquivo
            categoriaOrigem = this.arquivo.categoriaContabil.id;
        } else if (linha.tipoTransacao === 'C') {
            // Para crédito: o destino é a conta contábil do arquivo
            categoriaDestino = this.arquivo.categoriaContabil.id;
        }

        // Buscar argumentos para CONTA e EXTRATO separadamente
        Promise.all([
            this.conjuntoCategoriaContabilService.getByDescricao(linha.descricaoTransacao, categoriaOrigem, categoriaDestino).toPromise()
        ]).then(([argumentos]) => {
            this.loadingPopupService.closeDialog();

            const argumentosArray = argumentos as any[];

            // Verificar se não há argumentos
            if (!argumentosArray || argumentosArray.length === 0) {
                // Se não tiver permissão de inserção, apenas informar que não encontrou
                if (!this.perfilAcessoSec.insere) {
                    this.toastService.showAlerta('Nenhum conjunto de categorias contábeis encontrado para esta descrição de transação.');
                    return;
                }
                // Perguntar se deseja criar um novo argumento
                this.perguntarCriarNovoArgumento(linha);
                return;
            }

            // Se houver múltiplas opções, abrir dialog de seleção
            if (argumentosArray.length > 1) {
                const mapaNomesPlanosContas = new Map(this.planosContas.map(p => [p.id, p.planoConta]));
                const mapaNomesTiposLancamento = new Map(this.tiposLancamento.map(t => [t.id, t.descricao]));
                argumentosArray.forEach(item => {
                    item.nomeCategoriaOrigem = mapaNomesPlanosContas.get(item.idCategoriaOrigem);
                    item.nomeCategoriaDestino = mapaNomesPlanosContas.get(item.idCategoriaDestino);
                    item.nomeTipoLancamento = mapaNomesTiposLancamento.get(item.idTipoLancamento);
                });
                this.abrirDialogSelecao(linha, argumentosArray);
            } else {
                // Se houver apenas uma opção, aplicar automaticamente
                this.aplicarArgumento(linha, argumentosArray[0]);
            }
        }).catch(error => {
            console.error('Erro ao buscar argumentos para linha:', linha.id, error);
            this.loadingPopupService.closeDialog();
            this.toastService.showAlerta('Erro ao processar preenchimento automático. Tente novamente.');
        });
    }

    calcularEstatisticas(): void {
        this.estatisticas.totalLinhas = this.linhas.length;

        // Contar linhas duplicadas (status 'I')
        this.estatisticas.duplicadas = this.linhas.filter(linha => linha.statusProcessado === 'I').length;

        // Contar linhas ignoradas
        this.estatisticas.ignoradas = this.linhas.filter(linha => this.isLinhaIgnorada(linha)).length;

        // Contar linhas associadas considerando a nova lógica
        this.estatisticas.associadas = this.linhas.filter(linha => {
            if (this.isLinhaIgnorada(linha)) {
                return false;
            }

            // Excluir linhas duplicadas
            if (linha.statusProcessado === 'I') {
                return false;
            }

            return linha.importado;
        }).length;

        // Linhas sem conta contábil são as que não estão associadas, nem ignoradas, nem duplicadas
        this.estatisticas.semContaContabil = this.estatisticas.totalLinhas - this.estatisticas.associadas - this.estatisticas.ignoradas - this.estatisticas.duplicadas;

        // Calcular percentual de associação (considerando apenas linhas processáveis: não ignoradas e não duplicadas)
        const linhasProcessaveis = this.estatisticas.totalLinhas - this.estatisticas.ignoradas - this.estatisticas.duplicadas;
        this.estatisticas.percentualAssociacao = linhasProcessaveis > 0
            ? Math.round((this.estatisticas.associadas / linhasProcessaveis) * 100)
            : 0;

        // Determinar status de associação
        if (this.estatisticas.totalLinhas === 0) {
            this.estatisticas.statusAssociacao = 'SEM_LINHAS';
        } else if (this.estatisticas.semContaContabil === 0) {
            this.estatisticas.statusAssociacao = 'TOTALMENTE_ASSOCIADO';
        } else if (this.estatisticas.associadas > 0) {
            this.estatisticas.statusAssociacao = 'PARCIALMENTE_ASSOCIADO';
        } else {
            this.estatisticas.statusAssociacao = 'NAO_ASSOCIADO';
        }

        // Contar pendências de integração (importadas mas com falha na integração com a base)
        this.estatisticas.pendentesIntegracao = this.linhas.filter(linha => linha.importado && linha.statusAtualizadoBase !== 'S').length;

        // Calcular valores
        this.estatisticas.valorTotal = this.linhas.reduce((total, linha) => total + (linha.valorExtrato || 0), 0);
        this.estatisticas.valorAssociado = this.linhas
            .filter(linha => this.isLinhaAssociada(linha))
            .reduce((total, linha) => total + (linha.valorExtrato || 0), 0);
        this.estatisticas.valorIgnorado = this.linhas
            .filter(linha => this.isLinhaIgnorada(linha))
            .reduce((total, linha) => total + (linha.valorExtrato || 0), 0);
        this.estatisticas.valorDuplicado = this.linhas
            .filter(linha => linha.statusProcessado === 'I')
            .reduce((total, linha) => total + (linha.valorExtrato || 0), 0);
        this.estatisticas.valorPendente = this.estatisticas.valorTotal - this.estatisticas.valorAssociado - this.estatisticas.valorIgnorado - this.estatisticas.valorDuplicado;
    }

    obterStatusAssociacaoTexto(): string {
        switch (this.estatisticas.statusAssociacao) {
            case 'TOTALMENTE_ASSOCIADO':
                return 'Totalmente Associado';
            case 'PARCIALMENTE_ASSOCIADO':
                return 'Parcialmente Associado';
            case 'NAO_ASSOCIADO':
                return 'Aguardando';
            case 'SEM_LINHAS':
                return 'Sem Linhas';
            default:
                return 'Não Informado';
        }
    }

    obterCorStatusAssociacao(): string {
        switch (this.estatisticas.statusAssociacao) {
            case 'TOTALMENTE_ASSOCIADO':
                return '#4caf50'; // Verde
            case 'PARCIALMENTE_ASSOCIADO':
                return '#ff9800'; // Laranja
            case 'NAO_ASSOCIADO':
                return '#4ea125'; // Vermelho
            case 'SEM_LINHAS':
                return '#666'; // Cinza
            default:
                return '#666';
        }
    }

    abrirDialogCadastrarArgumento(linha: LinhaExtrato): void {
        // Verificar permissão de inserção ou alteração no perfil secundário
        if (!this.perfilAcessoSec.insere && !this.perfilAcessoSec.altera) {
            this.toastService.showAlerta('Você não tem permissão para criar ou alterar conjuntos de contas contábeis.');
            return;
        }

        var associacao = this.associacoes.get(linha.id);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '600px';
        dialogConfig.maxWidth = '90vw';
        dialogConfig.data = {
            descricaoTransacao: linha.descricaoTransacao || '',
            tipoTransacao: linha.tipoTransacao, // Passa o tipo (D ou C)
            idCategoriaOrigem: associacao?.idCategoriaOrigem || linha.categoriaOrigem?.id || null,
            idCategoriaDestino: associacao?.idCategoriaDestino || linha.categoriaDestino?.id || null,
            categoriaContabilArquivo: this.arquivo.categoriaContabil?.id || null,
            planosContas: this.planosContas || [],
            tiposLancamento: this.tiposLancamento || []
        };

        const dialogRef = this.dialog.open(CadastrarConjuntoCategoriaContabilDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((argumentoCriado: ConjuntoCategoriaContabil | null) => {
            if (argumentoCriado) {
                // Verificar se o argumento tem a mesma categoria que já está na linha
                let categoriasIguais = false;

                if (linha.tipoTransacao === 'C') {
                    // Para crédito, verifica categoriaOrigem
                    categoriasIguais = linha.categoriaOrigem?.id === argumentoCriado.idCategoriaOrigem;
                } else if (linha.tipoTransacao === 'D') {
                    // Para débito, verifica categoriaDestino
                    categoriasIguais = linha.categoriaDestino?.id === argumentoCriado.idCategoriaDestino;
                }

                // Verificar se o tipo de importação do conjunto já está aplicado na linha (ou não foi informado)
                const tipoLancamentoIgual = !argumentoCriado.idTipoLancamento ||
                    linha.tipoLancamento?.id === argumentoCriado.idTipoLancamento;

                if (categoriasIguais && tipoLancamentoIgual) {
                    // Se a categoria e o tipo de importação são iguais, não precisa perguntar - apenas não faz nada
                    // O dialog já mostrou a mensagem de sucesso
                    return;
                } else {
                    // Se a categoria é diferente, perguntar se deseja aplicar
                    this.perguntarAplicarArgumento(linha, argumentoCriado);
                }
            }
        });
    }

    tentarAssociarTodas(): void {
        // Obter todas as linhas que não estão associadas (excluindo ignoradas e duplicadas/inválidas)
        const linhasSemContaContabil = this.linhas.filter(linha => {
            // Não está ignorada, não está duplicada/inválida e não está associada
            return !this.isLinhaIgnorada(linha) &&
                linha.statusProcessado !== 'I' &&
                !this.isLinhaAssociada(linha);
        });

        if (linhasSemContaContabil.length === 0) {
            this.toastService.showAlerta('Não há lançamentos sem conta contábil para associar.');
            return;
        }

        // Verificar se há linhas já associadas
        const temAssociadas = this.temLinhasAssociadas();

        if (temAssociadas) {
            // Se há linhas associadas, mostrar dialog de escolha
            const todasLinhasProcessaveis = this.linhas.filter(linha => {
                return !this.isLinhaIgnorada(linha) && linha.statusProcessado !== 'I';
            });

            const dialogConfig = new MatDialogConfig();
            dialogConfig.width = '500px';
            dialogConfig.data = {
                linhasSemContaContabil: linhasSemContaContabil.length,
                totalLinhas: todasLinhasProcessaveis.length
            };

            const dialogRef = this.dialog.open(EscolherTipoAssociacaoDialogComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((escolha: string | null) => {
                if (escolha === 'semContaContabil') {
                    this.processarAssociacaoEmLote(linhasSemContaContabil);
                } else if (escolha === 'todas') {
                    this.processarTodasAsLinhas();
                }
                // Se escolha for null (cancelou), não faz nada
            });
        } else {
            // Se não há linhas associadas, usar o comportamento original (confirmar e processar sem conta contábil)
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
                pergunta: `Deseja tentar associar automaticamente ${linhasSemContaContabil.length} lançamento(s) sem conta contábil?`,
                textoConfirma: 'SIM',
                textoCancela: 'NÃO'
            };

            const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((confirma: boolean) => {
                if (confirma) {
                    this.processarAssociacaoEmLote(linhasSemContaContabil);
                }
            });
        }
    }

    private temLinhasAssociadas(): boolean {
        return this.linhas.some(linha => this.isLinhaAssociada(linha));
    }

    private processarTodasAsLinhas(): void {
        // Obter todas as linhas processáveis (não ignoradas e não duplicadas)
        const todasLinhas = this.linhas.filter(linha => {
            return !this.isLinhaIgnorada(linha) && linha.statusProcessado !== 'I';
        });

        if (todasLinhas.length === 0) {
            this.toastService.showAlerta('Não há lançamentos para processar.');
            return;
        }

        this.processarAssociacaoEmLote(todasLinhas);
    }

    private abrirDialogSelecao(linha: LinhaExtrato, argumentos: ConjuntoCategoriaContabil[]): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '600px';
        dialogConfig.data = {
            argumentos: argumentos
        };

        const dialogRef = this.dialog.open(SelecionarConjuntoCategoriaContabilDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((argumentoSelecionado: ConjuntoCategoriaContabil | null) => {
            if (argumentoSelecionado) {
                this.aplicarArgumento(linha, argumentoSelecionado);
            }
            // Se cancelou (null), não faz nada
        });
    }

    private aplicarArgumento(linha: LinhaExtrato, argumento: ConjuntoCategoriaContabil): void {
        let sucesso = false;
        let mensagem = '';

        // Para linhas de CRÉDITO: aplicar apenas categoriaOrigem (destino vem do arquivo)
        if (linha.tipoTransacao === 'C' && argumento.idCategoriaOrigem) {
            const planoConta = _.cloneDeep(_.find(this.planosContas, {id: argumento.idCategoriaOrigem}));

            if (planoConta) {
                linha.categoriaOrigem = planoConta;
                this.atualizarAssociacao(linha, 'categoriaOrigem', planoConta.id);
                sucesso = true;
                mensagem = `Origem: ${planoConta.planoConta}`;
            }
        }
        // Para linhas de DÉBITO: aplicar apenas categoriaDestino (origem vem do arquivo)
        else if (linha.tipoTransacao === 'D' && argumento.idCategoriaDestino) {
            const planoConta = _.cloneDeep(_.find(this.planosContas, {id: argumento.idCategoriaDestino}));

            if (planoConta) {
                linha.categoriaDestino = planoConta;
                this.atualizarAssociacao(linha, 'categoriaDestino', planoConta.id);
                sucesso = true;
                mensagem = `Destino: ${planoConta.planoConta}`;
            }
        }

        // Preenche o tipo de importação quando cadastrado no conjunto utilizado
        if (sucesso && argumento.idTipoLancamento) {
            const tipoLancamento = this.tiposLancamento.find(t => t.id === argumento.idTipoLancamento);
            if (tipoLancamento) {
                linha.tipoLancamento = tipoLancamento;
                this.atualizarAssociacao(linha, 'tipoLancamento', tipoLancamento.id);
                mensagem += ` | Tipo Importação: ${tipoLancamento.descricao}`;
            }
        }

        if (sucesso) {
            this.calcularEstatisticas();
            this.toastService.showSucesso(`Categoria preenchida automaticamente: ${mensagem}`);
        } else {
            this.toastService.showAlerta('Não foi possível aplicar a categoria do argumento selecionado.');
        }
    }

    private perguntarCriarNovoArgumento(linha: LinhaExtrato): void {
        // Verificar permissão de inserção no perfil secundário
        if (!this.perfilAcessoSec.insere) {
            this.toastService.showAlerta('Nenhum conjunto de categorias contábeis encontrado para esta descrição de transação.');
            return;
        }

        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: 'Nenhum argumento encontrado para esta descrição de transação. Deseja criar um novo argumento?',
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma: boolean) => {
            if (confirma) {
                this.abrirDialogCadastrarArgumento(linha);
            }
        });
    }

    private atualizarAssociacao(linha: LinhaExtrato, tipo: string, valor: any): void {
        if (!this.associacoes.has(linha.id)) {
            this.associacoes.set(linha.id, {
                idLinhaExtrato: linha.id,
                idCategoriaOrigem: linha.categoriaOrigem?.id,
                idCategoriaDestino: linha.categoriaDestino?.id,
                idCategoriaAdicional: linha.categoriaAdicional?.id,
                idEmpresa: linha.empresa?.id,
                idTipoLancamento: linha.tipoLancamento?.id,
                observacoes: linha.observacoes,
                descricaoLinha: linha.descricaoLinha,
                ignorar: linha.ignorar
            });
        }

        const associacao = this.associacoes.get(linha.id);

        // Atualiza o valor específico que foi alterado
        if (tipo === 'categoriaOrigem') {
            associacao.idCategoriaOrigem = valor;
        } else if (tipo === 'categoriaDestino') {
            associacao.idCategoriaDestino = valor;
        } else if (tipo === 'categoriaAdicional') {
            associacao.idCategoriaAdicional = valor;
        } else if (tipo === 'empresa') {
            associacao.idEmpresa = valor;
        } else if (tipo === 'tipoLancamento') {
            associacao.idTipoLancamento = valor;
        } else if (tipo === 'descricaoLinha') {
            associacao.descricaoLinha = valor;
        }

        // Importante: não copiar valores atuais da linha, pois a categoria fixa
        // do arquivo será aplicada automaticamente no backend baseada no tipo
    }

    private perguntarAplicarArgumento(linha: LinhaExtrato, argumento: ConjuntoCategoriaContabil): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: 'Deseja aplicar este argumento à linha atual?',
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma: boolean) => {
            if (confirma) {
                this.aplicarArgumento(linha, argumento);
            }
        });
    }

    private async processarAssociacaoEmLote(linhas: LinhaExtrato[]): Promise<void> {
        this.loadingPopupService.mostrarMensagemDialog(`Processando ${linhas.length} lançamento(s)...`);

        let sucessoCount = 0;
        let erroCount = 0;

        // Processar linhas sequencialmente para evitar sobrecarga
        for (let i = 0; i < linhas.length; i++) {
            const linha = linhas[i];
            this.loadingPopupService.mostrarMensagemDialog(`Processando linha ${i + 1} de ${linhas.length}...`);

            try {
                // Determinar categoria origem ou destino baseado no tipo de transação
                let categoriaOrigem: number | undefined;
                let categoriaDestino: number | undefined;

                if (linha.tipoTransacao === 'D') {
                    // Para débito: a origem é a conta contábil do arquivo
                    categoriaOrigem = this.arquivo.categoriaContabil.id;
                } else if (linha.tipoTransacao === 'C') {
                    // Para crédito: o destino é a conta contábil do arquivo
                    categoriaDestino = this.arquivo.categoriaContabil.id;
                }

                // Buscar argumentos para a linha com filtro de categoria
                const argumentos = await this.conjuntoCategoriaContabilService.getByDescricao(
                    linha.descricaoTransacao, categoriaOrigem, categoriaDestino).toPromise();
                const argumentosArray = argumentos as ConjuntoCategoriaContabil[];

                if (argumentosArray && argumentosArray.length === 1) {
                    // Se houver apenas uma opção, aplicar automaticamente
                    // Se houver múltiplas, usar a primeira (ou poderia abrir dialog, mas para lote usamos a primeira)
                    const argumento = argumentosArray[0];
                    this.aplicarArgumento(linha, argumento);
                    sucessoCount++;
                } else {
                    erroCount++;
                }
            } catch (error) {
                console.error(`Erro ao processar linha ${linha.id}:`, error);
                erroCount++;
            }
        }

        this.loadingPopupService.closeDialog();

        // Mostrar resultado
        let mensagem = `Processamento concluído: ${sucessoCount} lançamento(s) processado(s) com sucesso`;
        if (erroCount > 0) {
            mensagem += `, ${erroCount} lançamento(s) não puderam ser processados`;
        }
        mensagem += '.';

        this.toastService.showSucesso(mensagem);
        if (sucessoCount > 0)
            this.calcularEstatisticas();
    }

    isCategoriaDesabilitado(linha: LinhaExtrato, origem: Boolean): Boolean {
        // Se a linha está inválida/duplicada, desabilitar tudo
        if (linha.statusProcessado === 'I' || linha.importado) {
            return true;
        }

        var desabilitado: boolean;
        if (origem)
            desabilitado = (!this.perfilAcesso.insere && linha.categoriaOrigem === undefined) || (!this.perfilAcesso.altera && linha.categoriaOrigem !== undefined);
        else
            desabilitado = (!this.perfilAcesso.insere && linha.categoriaDestino === undefined) || (!this.perfilAcesso.altera && linha.categoriaDestino !== undefined);

        if (this.associacoes.has(linha.id))
            desabilitado = false;

        return desabilitado;
    }

    isLinhaDesabilitada(linha: LinhaExtrato): Boolean {
        // Se a linha está inválida/duplicada, desabilitar tudo
        if (linha.statusProcessado === 'I' || linha.importado) {
            return true;
        }

        var desabilitado = (!this.perfilAcesso.insere && linha.categoriaOrigem === undefined) || (!this.perfilAcesso.altera && linha.categoriaOrigem !== undefined);
        if (desabilitado)
            desabilitado = (!this.perfilAcesso.insere && linha.categoriaDestino === undefined) || (!this.perfilAcesso.altera && linha.categoriaDestino !== undefined);

        return desabilitado;
    }

    /**
     * Carrega o perfil de acesso secundário e define a permissão de associação
     */
    private carregarPerfilSecundario(): void {
        this.acessoService.getPerfilAcesso(this.activatedRoute.snapshot.data.moduloSecundario).pipe(
            switchMap((perfilAcesso: Acesso[]) => {
                if (_.isEmpty(perfilAcesso) || !perfilAcesso[0].consulta)
                    return of(null);
                return of(perfilAcesso);
            })
        ).subscribe((perfilSecundario: Acesso[]) => this.carregarPerfil.carregar(perfilSecundario, this.perfilAcessoSec));
    }

    podeAbrirDialogCadastrarArgumento(): boolean {
        return !!(this.arquivo?.categoriaContabil?.id);
    }

    podePreencherAutomaticamente(): boolean {
        return !!(this.arquivo?.categoriaContabil?.id) && this.podeImportar();
    }

    podeSalvar(): boolean {
        return !!(this.arquivo?.categoriaContabil?.id && this.arquivo?.contaBancaria?.id);
    }

    podeImportar(): boolean {
        return this.linhas.filter(linha => !linha.importado && linha.statusProcessado !== 'I').length > 0;
    }

    toggleResumo(): void {
        this.resumoExpandido = !this.resumoExpandido;
    }

    private converterContasBancariasParaOpcoes(): void {
        this.contasBancariasOpcoes = this.contasBancarias.map(conta => ({
            id: conta.id,
            nome: `${conta.banco.numero} - ${conta.banco.nome} | Ag. ${conta.numeroAgencia} | C. ${conta.numeroContaBancaria}`
        }));
    }
}
